import React from 'react';
import useToggle from '../../hooks/useToggle';
export const withFocus = (Component) => React.forwardRef((props, ref) => {
    const [isFocused, handleFocus, handleBlur] = useToggle();
    const withToggleProps = { isFocused, handleFocus, handleBlur };
    return React.createElement(Component, { ...withToggleProps, ...props, ref: ref });
});
export default withFocus;
//# sourceMappingURL=index.js.map